import axios from 'axios';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import { adminMainUrl } from '../../../../../../../Config';
import { toast } from 'react-toastify';
import Select from 'react-select'
import { customStyles } from '../../../../../../../HelperFunctions';
import TextAreaJSX from './TextAreaJSX';
import InputTextJSX from './InputTextJSX';
import InputDateJSX from './InputDateJSX';
import SelectReactJSX from './SelectReactJSX';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from "js-cookie";
import { calculateTotalFreightMAWB, getFFSeaImpAirport, getFFSeaImpConsigneeBranch, getFFSeaImpConsigneeBranchBank, getFFSeaImpCurrency, getFFSeaImpFinalQuotation, getFFSeaImpJobOrder, getFFSeaImpOrganisation, getFFSeaImpOrganisationBranch, getFFSeaImpShipperBranch, getFFSeaImpShipperBranchBank, getFFSeaImpUnusedHBLList, getFFSISeaport } from '../../../../../../../Redux/action/FreightForwarding/Sea/FFSeaImpAction';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';

const ConsoleShipmentSIMBLAdd = ({ accessedPermission }) => {
    const [disableSubmit, setDisableSubmit] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const urlString = window.location.href;
    const url = new URL(urlString);
    const path = url.pathname.slice(1);
    const searchParams = url.search;
    const q = path + searchParams;
    const token = Cookies.get('token');
    const user_id = Cookies.get('flexichain_user_id');


    useEffect(() => {
        if (token && user_id) {
            dispatch(getFFSeaImpJobOrder(token, user_id));
            dispatch(getFFSeaImpFinalQuotation(token, user_id));
            dispatch(getFFSeaImpCurrency(token, user_id));
            dispatch(getFFSeaImpAirport(token, user_id));
            dispatch(getFFSeaImpOrganisation(token, user_id));
            dispatch(getFFSeaImpUnusedHBLList(token, user_id));
            dispatch(getFFSISeaport(token, user_id));
        } else {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        }

    }, [token, user_id]);

    const [modalShow, setModalShow] = React.useState(false);

    const {

        loadingFFSeaImpJobOrderList,
        FFSeaImpJobOrderListError,
        FFSeaImpJobOrderList,

        loadingFFSeaImpFinalQuotationList,
        FFSeaImpFinalQuotationListError,
        FFSeaImpFinalQuotationList,

        loadingFFSeaImpCurrencyList,
        FFSeaImpCurrencyListError,
        FFSeaImpCurrencyList,

        loadingFFSeaImpAirportList,
        FFSeaImpAirportListError,
        FFSeaImpAirportList,

        //organisation list
        loadingFFSeaImpOrganisationList,
        FFSeaImpOrganisationList,
        FFSeaImpOrganisationListError,


        //organisation shipper branch list
        loadingFFSeaImpShipperBranchList,
        FFSeaImpShipperBranchList,
        FFSeaImpShipperBranchListError,

        //organisation consignee branch list
        loadingFFSeaImpConsigneeBranchList,
        FFSeaImpConsigneeBranchList,
        FFSeaImpConsigneeBranchListError,

        //organisatoin shipper branch bank list
        loadingFFSeaImpShipperBranchBankList,
        FFSeaImpShipperBranchBankList,
        FFSeaImpShipperBranchBankListError,

        //organisatoin consignee branch bank list
        loadingFFSeaImpConsigneeBranchBankList,
        FFSeaImpConsigneeBranchBankList,
        FFSeaImpConsigneeBranchBankListError,

        //unused hawb list
        loadingFFSeaImpUnusedHBLList,
        FFSeaImpUnusedHBLList,
        FFSeaImpUnusedHAWBLiBLrror,

        //mawb -> calculate total freight hawb
        loadingFFSeaImpTotalFreight,
        FFSeaImpTotalFreight,
        FFSeaImpTotalFreightError,

        loadingFFSISeaport,
        FFSISeaport,
        FFSISeaportError,
    } = useSelector(state => state.FFSeaImpReducer);


    let [seaportOptions, setSeaportOptions] = useState([]);

    useEffect(() => {
        if (FFSISeaport) {
            let arr = [];
            FFSISeaport.map(val => arr.push({ value: val.id, label: val.name }));
            setSeaportOptions(arr);
        }
    }, [loadingFFSISeaport, FFSISeaport])



    const [jobOrderOptions, setJobOrderOptions] = useState([]);
    useEffect(() => {
        if (FFSeaImpJobOrderList) {
            let arr = [];
            FFSeaImpJobOrderList.map(val => arr.push({ value: val.id, label: val.job_order_unique_no, quotation_id: Number(val.quotation_id) }));
            setJobOrderOptions(arr);
        }
    }, [loadingFFSeaImpJobOrderList, FFSeaImpJobOrderList]);

    const [unusedHBLOptions, setUnusedHBLptions] = useState([]);
    useEffect(() => {
        if (FFSeaImpUnusedHBLList) {
            let arr = [];
            FFSeaImpUnusedHBLList.map(val => arr.push({ value: val.id, label: val.hbl_number }));
            setUnusedHBLptions(arr);
        }
    }, [loadingFFSeaImpUnusedHBLList, FFSeaImpUnusedHBLList]);

    const [organisationOptions, setOrganisationOptions] = useState([]);
    useEffect(() => {
        if (FFSeaImpOrganisationList) {
            let arr = [];
            FFSeaImpOrganisationList.map(val => arr.push({ value: val.id, label: `${val.name} (${val.customerType})`, entity: val.entity_type ? JSON.parse(val.entity_type) : [] }));
            setOrganisationOptions(arr);
        }
    }, [FFSeaImpOrganisationList]);

    const [finalQuotationOptions, setFinalQuotationOptions] = useState([]);
    useEffect(() => {
        if (FFSeaImpFinalQuotationList) {
            let arr = [];
            FFSeaImpFinalQuotationList.map(val => arr.push({ value: val.id, label: val.ship_quotation_no }));
            setFinalQuotationOptions(arr);
        }
    }, [loadingFFSeaImpFinalQuotationList, FFSeaImpFinalQuotationList]);

    const [currencyOptions, setCurrencyOptions] = useState([]);
    useEffect(() => {
        if (FFSeaImpCurrencyList) {
            let arr = [];
            FFSeaImpCurrencyList.map(val => arr.push({ value: val.id, label: `${val.currency} (${val.currency_symbol})` }));
            setCurrencyOptions(arr);
        }
    }, [loadingFFSeaImpCurrencyList, FFSeaImpCurrencyList]);

    const [airportOptions, setAirportOptions] = useState([]);
    useEffect(() => {
        if (FFSeaImpAirportList) {
            let arr = [];
            FFSeaImpAirportList.map(val => arr.push({ value: val.id, label: `${val.name} (${val.code}) - ${val.country_name}` }));
            setAirportOptions(arr);
        }
    }, [loadingFFSeaImpAirportList, FFSeaImpAirportList]);


    let [shipperOrganisationOptions, setShipperOrganisationOptions] = useState([]);
    let [consigneeOrganisationOptions, setConsigneeOrganisationOptions] = useState([]);

    let [shipperBranchOptions, setShipperBranchOptions] = useState([]);
    let [consigneeBranchOptions, setConsigneeBranchOptions] = useState([]);


    useEffect(() => {
        if (organisationOptions) {
            let shipperArr = [];
            let consigneeArr = [];

            organisationOptions.map(object => {
                if (object.entity && object.entity.includes("shipper")) {
                    shipperArr.push(object);
                }
                if (object.entity && object.entity.includes("consignee")) {
                    consigneeArr.push(object);
                }
            });
            setShipperOrganisationOptions(shipperArr);
            setConsigneeOrganisationOptions(consigneeArr);
        }
    }, [organisationOptions]);


    const handleShipperBranch = (shipper_id) => {
        if (shipper_id && token && user_id) {
            dispatch(getFFSeaImpShipperBranch(token, user_id, shipper_id));
        }
    };


    const handleConsigneeBranch = (consignee_id) => {
        if (consignee_id && token && user_id) {
            dispatch(getFFSeaImpConsigneeBranch(token, user_id, consignee_id));
        }
    };



    useEffect(() => {
        // console.log(FFSeaImpShipperBranchList);
        if (FFSeaImpShipperBranchList) {
            let arr = [];
            FFSeaImpShipperBranchList.map(val => arr.push({ value: val.id, label: val.branch_name }));
            setShipperBranchOptions(arr);
        }
    }, [FFSeaImpShipperBranchList]);



    useEffect(() => {
        if (FFSeaImpConsigneeBranchList) {
            let arr = [];
            FFSeaImpConsigneeBranchList.map(val => arr.push({ value: val.id, label: val.branch_name }));
            setConsigneeBranchOptions(arr);
        }
    }, [FFSeaImpConsigneeBranchList]);


    // const initialValues = {
    //     shipper_id: "",
    //     shipper_branch_id: "",
    //     shipper_branch_bank_account_id: "",
    //     consignee_id: "",
    //     consignee_branch_id: "",
    //     consignee_branch_bank_account_id: "",
    //     issuing_carrier_agent_name: "",
    //     issuing_carrier_agent_address: "",
    //     agent_iata_code: "",
    //     agent_account_number: "",
    //     hawb_collection: [],
    //     handling_info: "",
    //     nature_and_qty: "",
    //     remarks: "",
    //     airwaybill_date: "",
    //     clearance_Exec_date: "",
    //     CSR_date: "",
    //     executed_at: "",
    //     airport_of_departure_id: "",
    //     airport_of_departure_name: "",
    //     airport_of_destination_id: "",
    //     airport_of_destination_name: "",
    //     to_one: "",
    //     by_first_carrier: "",
    //     to_two: "",
    //     by_one: "",
    //     to_three: "",
    //     by_two: "",
    //     flight_no_one: "",
    //     flight_date_one: "",
    //     flight_no_two: "",
    //     flight_date_two: "",
    //     cto: "",
    //     currency: "",
    //     chgs_code: "",
    //     wt_val: "",
    //     other: "",
    //     declared_value_for_carriage: "",
    //     declared_value_for_customs: "",
    //     amount_of_insurance: "",
    //     weight_charge_prepaid: "",
    //     weight_charge_collect: "",
    //     valuation_charge_prepaid: "",
    //     valuation_charge_collect: "",
    //     tax_prepaid: "",
    //     tax_collect: "",
    //     total_due_agent_prepaid: "",
    //     total_due_agent_collect: "",
    //     total_due_carrier_prepaid: "",
    //     total_due_carrier_collect: "",
    //     confirm_mawb_generate: ""
    // }

    const initialValues = {
        carrier_reference_no: "",
        swb_no: "",
        shipper_id: "",
        shipper_branch_id: "",
        consignee_id: "",
        consignee_branch_id: "",
        consignee_tax_id: "",
        consignee_zc: "",
        hbl_collection: [],
        export_reference: "",
        forwarding_agent: "",
        consignee_reference: "",
        place_of_receipt: "",
        place_of_delivery: "",
        notify_address: "",
        notify_email: "",
        notify_tax_id: "",
        notify_zc: "",
        vessel: "",
        vessel_no: "",
        port_of_loading: "",
        port_of_discharge: "",
        total_no_of_container_received_by_carrier: "",
        packages_received_by_carrier: "",
        movement: "",
        currency: "",
        charge: "",
        rate: "",
        basis: "",
        awt_vol_val: "",
        p_c_data: "",
        amount: "",
        place_of_issue: "",
        place_of_issue_date: "",
        freight_payable_at: "",
        confirm_mbl_generate: ""
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: (values, { resetForm }) => {

            // console.log(values);
            setDisableSubmit(true);
            try {
                let config = {
                    headers: {
                        'auth-token': token,
                        'user_id': user_id
                    }
                }
                axios.post(`${adminMainUrl}/api/freight/forwarding/sea/import/mbl/add`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            resetForm();
                            //reset all the dropdowns
                            setShipperOrganisationOptions([]);
                            setConsigneeOrganisationOptions([]);
                            setShipperBranchOptions([]);
                            setConsigneeBranchOptions([]);
                            navigate(`/flexichain/job-order/freight-forwarding/shipment/sea/import/console/mbl`)
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error)
                        toast.error(error.response.data.msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });




    const handleFormSubmission = (val) => {
        formik.setFieldValue("confirm_mbl_generate", val);
        setModalShow(false);
        formik.handleSubmit();
    }


    return (
        <>
            <div className="page-wrapper">
                <div className="content">
                    <div className="card">
                        <div className="card-body">
                            <form onSubmit={formik.handleSubmit}>
                                <div className="row">

                                    <h3 className='mt-2'>MBL</h3>
                                    <h4 className='mt-2'>Party Details</h4>

                                    <InputTextJSX labelText={"Carrier's Reference No."} nameValue={"carrier_reference_no"} value={formik.values.carrier_reference_no} onChange={formik.handleChange} />
                                    <InputTextJSX labelText={"SWB No."} nameValue={"swb_no"} value={formik.values.swb_no} onChange={formik.handleChange} />

                                    <div className="col-md-6 mt-2">
                                        <div className='ms-2'>
                                            <label htmlFor="" className='form-label  mb-0'>
                                                Shipper
                                            </label>
                                            <div className="icon-forms mb-3 mb-sm-0">
                                                <Select
                                                    className='custom-selector'
                                                    options={shipperOrganisationOptions}
                                                    styles={customStyles}
                                                    name="shipper_id"
                                                    onChange={option => {
                                                        formik.setFieldValue("shipper_branch_id", "");
                                                        setShipperBranchOptions([]);
                                                        formik.setFieldValue('shipper_id', option.value);
                                                        handleShipperBranch(option.value);
                                                    }}
                                                    value={shipperOrganisationOptions.find(option => option.value === formik.values.shipper_id || null)}
                                                    isLoading={loadingFFSeaImpOrganisationList}
                                                    isDisabled={false}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 mt-2">
                                        <div className='ms-2'>
                                            <label htmlFor="" className='form-label  mb-0'>
                                                Shipper Branch
                                            </label>
                                            <div className="icon-forms mb-3 mb-sm-0">
                                                <Select
                                                    className='custom-selector'
                                                    options={shipperBranchOptions}
                                                    styles={customStyles}
                                                    name="shipper_branch_id"
                                                    onChange={option => {

                                                        formik.setFieldValue('shipper_branch_id', option.value);

                                                    }}
                                                    value={shipperBranchOptions.find(option => option.value === formik.values.shipper_branch_id || null)}
                                                    isLoading={loadingFFSeaImpShipperBranchList}
                                                // isDisabled={false}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 mt-2">
                                        <div className='ms-2'>
                                            <label htmlFor="" className='form-label  mb-0'>
                                                Consignee
                                            </label>
                                            <div className="icon-forms mb-3 mb-sm-0">
                                                <Select
                                                    className='custom-selector'
                                                    options={consigneeOrganisationOptions}
                                                    styles={customStyles}
                                                    name="quotation_id"
                                                    onChange={option => {
                                                        setConsigneeBranchOptions([]);
                                                        formik.setFieldValue("consignee_branch_id", "");
                                                        formik.setFieldValue('consignee_id', option.value);
                                                        handleConsigneeBranch(option.value);
                                                    }}
                                                    value={consigneeOrganisationOptions.find(option => option.value === formik.values.consignee_id || null)}
                                                    isLoading={loadingFFSeaImpOrganisationList}
                                                    isDisabled={false}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 mt-2">
                                        <div className='ms-2'>
                                            <label htmlFor="" className='form-label  mb-0'>
                                                Consignee Branch
                                            </label>
                                            <div className="icon-forms mb-3 mb-sm-0">
                                                <Select
                                                    className='custom-selector'
                                                    options={consigneeBranchOptions}
                                                    styles={customStyles}
                                                    name="consignee_branch_id"
                                                    onChange={option => {
                                                        formik.setFieldValue('consignee_branch_id', option.value);
                                                    }}
                                                    value={consigneeBranchOptions.find(option => option.value === formik.values.consignee_branch_id || null)}
                                                    isLoading={loadingFFSeaImpShipperBranchList}
                                                    isDisabled={false}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <InputTextJSX labelText={"Consignee TAX ID"} nameValue={"consignee_tax_id"} value={formik.values.consignee_tax_id} onChange={formik.handleChange} maxLength={20} />
                                    <InputTextJSX labelText={"Consignee ZC"} nameValue={"consignee_zc"} value={formik.values.consignee_zc} onChange={formik.handleChange} maxLength={10} />
                                    <InputTextJSX labelText={"Export Reference"} nameValue={"export_reference"} value={formik.values.export_reference} onChange={formik.handleChange} maxLength={100} />
                                    <InputTextJSX labelText={"Forwarding Agent"} nameValue={"forwarding_agent"} value={formik.values.forwarding_agent} onChange={formik.handleChange} maxLength={100} />
                                    <InputTextJSX labelText={"Consginee Reference"} nameValue={"consignee_reference"} value={formik.values.consignee_reference} onChange={formik.handleChange} maxLength={100} />
                                    <InputTextJSX labelText={"Place of Receipt"} nameValue={"place_of_receipt"} value={formik.values.place_of_receipt} onChange={formik.handleChange} maxLength={100} />
                                    <InputTextJSX labelText={"Place of Delivery"} nameValue={"place_of_delivery"} value={formik.values.place_of_delivery} onChange={formik.handleChange} maxLength={100} />
                                    <InputTextJSX labelText={"Notify Address"} nameValue={"notify_address"} value={formik.values.notify_address} onChange={formik.handleChange} maxLength={100} />
                                    <InputTextJSX labelText={"Notify Email"} nameValue={"notify_email"} value={formik.values.notify_email} onChange={formik.handleChange} maxLength={100} />
                                    <InputTextJSX labelText={"Notify TAX ID"} nameValue={"notify_tax_id"} value={formik.values.notify_tax_id} onChange={formik.handleChange} maxLength={100} />
                                    <InputTextJSX labelText={"Notify ZC"} nameValue={"notify_zc"} value={formik.values.notify_zc} onChange={formik.handleChange} maxLength={10} />
                                    <InputTextJSX labelText={"Vessel"} nameValue={"vessel"} value={formik.values.vessel} onChange={formik.handleChange} maxLength={100} />
                                    <InputTextJSX labelText={"Vessel No"} nameValue={"vessel_no"} value={formik.values.vessel_no} onChange={formik.handleChange} maxLength={100} />

                                    <div className="col-md-6 mt-2">
                                        <div className='ms-2'>
                                            <label htmlFor="" className='form-label  mb-0'>
                                                Port of Loading
                                            </label>
                                            <div className="icon-forms mb-3 mb-sm-0">
                                                <Select
                                                    className='custom-selector'
                                                    options={seaportOptions}
                                                    styles={customStyles}
                                                    name="port_of_loading"
                                                    onChange={option => {
                                                        formik.setFieldValue('port_of_loading', option.value);
                                                    }}
                                                    value={seaportOptions.find(option => option.value == formik.values.port_of_loading || null)}
                                                    isLoading={loadingFFSeaImpConsigneeBranchBankList}
                                                // isDisabled={false}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 mt-2">
                                        <div className='ms-2'>
                                            <label htmlFor="" className='form-label  mb-0'>
                                                Port of Discharge
                                            </label>
                                            <div className="icon-forms mb-3 mb-sm-0">
                                                <Select
                                                    className='custom-selector'
                                                    options={seaportOptions}
                                                    styles={customStyles}
                                                    name="port_of_discharge"
                                                    onChange={option => {
                                                        formik.setFieldValue('port_of_discharge', option.value);
                                                    }}
                                                    value={seaportOptions.find(option => option.value == formik.values.port_of_discharge || null)}
                                                    isLoading={loadingFFSeaImpConsigneeBranchBankList}
                                                // isDisabled={false}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className={`col-md-6 mt-2`}>
                                        <div className='ms-2'>
                                            <label htmlFor="" className='form-label  mb-0'>
                                                Total No. of Continers received by Carrier
                                            </label>
                                            <div className="icon-forms mb-3 mb-sm-0">
                                                <input
                                                    type="text"
                                                    maxLength={5}
                                                    className="form-control form-control-sm"
                                                    id="total_no_of_container_received_by_carrier"
                                                    name="total_no_of_container_received_by_carrier"
                                                    value={formik.values.total_no_of_container_received_by_carrier}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <InputTextJSX labelText={"Packages received by Carrier"} nameValue={"packages_received_by_carrier"} value={formik.values.packages_received_by_carrier} onChange={formik.handleChange} />
                                    <InputTextJSX labelText={"Movement"} nameValue={"movement"} value={formik.values.movement} onChange={formik.handleChange} maxLength={20} />

                                    <div className="col-md-6 mt-2">
                                        <div className='ms-2'>
                                            <label htmlFor="" className='form-label  mb-0'>
                                                Currency
                                            </label>
                                            <div className="icon-forms mb-3 mb-sm-0">
                                                <Select
                                                    className='custom-selector'
                                                    options={currencyOptions}
                                                    styles={customStyles}
                                                    name="currency"
                                                    onChange={option => {
                                                        formik.setFieldValue('currency', option.value);
                                                    }}
                                                    value={currencyOptions.find(option => option.value == formik.values.currency || null)}
                                                    isLoading={loadingFFSeaImpConsigneeBranchBankList}
                                                // isDisabled={false}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* Agent Name */}
                                    <InputTextJSX labelText={"Charge"} nameValue={"charge"} value={formik.values.charge} onChange={formik.handleChange} />
                                    <InputTextJSX labelText={"Rate"} nameValue={"rate"} value={formik.values.rate} onChange={formik.handleChange} />
                                    <InputTextJSX labelText={"Basis"} nameValue={"basis"} value={formik.values.basis} onChange={formik.handleChange} />
                                    <InputTextJSX labelText={"AWT/Vol/Val"} nameValue={"awt_vol_val"} value={formik.values.awt_vol_val} onChange={formik.handleChange} />
                                    <InputTextJSX labelText={"P/C"} nameValue={"p_c_data"} value={formik.values.p_c_data} onChange={formik.handleChange} />
                                    <InputTextJSX labelText={"Amount"} nameValue={"amount"} value={formik.values.amount} onChange={formik.handleChange} />
                                    <InputTextJSX labelText={"Place of Issue"} nameValue={"place_of_issue"} value={formik.values.place_of_issue} onChange={formik.handleChange} />
                                    <div className={`col-md-6 mt-2`}>
                                        <div className='ms-2'>
                                            <label htmlFor="" className='form-label  mb-0'>
                                                Date of Issue
                                            </label>
                                            <div className="icon-forms mb-3 mb-sm-0">
                                                <input
                                                    type="date"
                                                    className="form-control form-control-sm"
                                                    id="place_of_issue_date"
                                                    name="place_of_issue_date"
                                                    value={formik.values.place_of_issue_date}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className={`col-md-6 mt-2`}>
                                        <div className='ms-2'>
                                            <label htmlFor="" className='form-label  mb-0'>
                                                Freight Payable At
                                            </label>
                                            <div className="icon-forms mb-3 mb-sm-0">
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    id="freight_payable_at"
                                                    name="freight_payable_at"
                                                    value={formik.values.freight_payable_at}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    maxLength={250}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {/* <InputTextJSX labelText={"Freight Payable At"} nameValue={"freight_payable_at"} value={formik.values.freight_payable_at} onChange={formik.handleChange} /> */}



                                    <h4 className='mt-2'>Select HBL No.</h4>
                                    <div className="col-md-12 mt-2">
                                        <div className='ms-2'>
                                            <label htmlFor="" className='form-label  mb-0'>
                                                HBL No.
                                            </label>
                                            <div className="icon-forms mb-3 mb-sm-0">
                                                <Select
                                                    className='custom-selector'
                                                    options={unusedHBLOptions}
                                                    // styles={customStyles}
                                                    name="hbl_collection"
                                                    onChange={selectedOptions => {
                                                        const values = selectedOptions ? selectedOptions.map(option => option.value) : [];
                                                        formik.setFieldValue("hbl_collection", values);
                                                    }}
                                                    value={unusedHBLOptions.filter(option =>
                                                        formik.values.hbl_collection.includes(option.value)
                                                    )}
                                                    isLoading={loadingFFSeaImpUnusedHBLList}
                                                    isDisabled={false}
                                                    isMulti={true}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="row d-flex justify-content-end mt-2">
                                    <div className="col-md-6 d-flex justify-content-end">
                                        <button type="button" className="btn btn-sm btn-danger" disabled={disableSubmit} onClick={() => setModalShow(true)}>
                                            {disableSubmit ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : "Add"}
                                        </button>
                                    </div>
                                </div>



                                <Modal
                                    show={modalShow}
                                    onHide={() => setModalShow(false)}
                                    // size="sm"
                                    aria-labelledby="contained-modal-title-vcenter"
                                    centered
                                >
                                    <Modal.Header closeButton>
                                        <Modal.Title id="contained-modal-title-vcenter">
                                            Do you want to Generate MBL No. ?
                                        </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <div className="d-flex justify-content-around">
                                            <button className="btn btn-primary btn-sm" type='submit' onClick={() => { handleFormSubmission("Yes") }} style={{ width: "30%" }}>
                                                Yes
                                            </button>
                                            <button className="btn btn-outline-primary btn-sm" type='submit' onClick={() => { handleFormSubmission("No") }} style={{ width: "30%" }}>
                                                No
                                            </button>
                                        </div>
                                    </Modal.Body>
                                </Modal>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ConsoleShipmentSIMBLAdd